import { HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../environment/environment.service";
export class EsimDevicesService {
    constructor(http, environmentService) {
        this.http = http;
        this.environmentService = environmentService;
        this.fallbackDevicesUrl = `/assets/esim_device.json`;
    }
    getEsimCompatibleDevices() {
        if (this.cachedDevices$) {
            return this.cachedDevices$;
        }
        const headers = new HttpHeaders({
            Accept: 'application/json',
        });
        const s3BaseUrl = this.environmentService.getAwsS3Url();
        const primaryUrl = s3BaseUrl ? `${s3BaseUrl}/assets/esim_device.json` : this.fallbackDevicesUrl;
        this.cachedDevices$ = this.http.get(primaryUrl, { headers }).pipe(catchError(error => {
            console.warn('Errore nel caricamento da URL primario:', primaryUrl, error);
            if (s3BaseUrl && primaryUrl !== this.fallbackDevicesUrl) {
                console.warn('Tentativo di fallback al file locale...');
                return this.http.get(this.fallbackDevicesUrl, { headers }).pipe(catchError(fallbackError => {
                    console.error('Errore anche nel fallback:', fallbackError);
                    this.cachedDevices$ = null;
                    return of({ brands: [] });
                }));
            }
            else {
                this.cachedDevices$ = null;
                return of({ brands: [] });
            }
        }), tap(data => {
            console.warn('Dispositivi eSIM caricati con successo da:', primaryUrl);
        }), shareReplay(1));
        return this.cachedDevices$;
    }
    reloadDevices() {
        this.cachedDevices$ = null;
        return this.getEsimCompatibleDevices();
    }
    getDataSource() {
        const s3BaseUrl = this.environmentService.getAwsS3Url();
        return s3BaseUrl ? 'AWS S3' : 'Local Assets';
    }
}
EsimDevicesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EsimDevicesService_Factory() { return new EsimDevicesService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvironmentService)); }, token: EsimDevicesService, providedIn: "root" });
